import { Stack } from "@mui/material";
import { type RecentColleague } from "@src/appV2/Agents/api/useGetRecentColleagues";
import { uniqBy } from "lodash";

import { type WorkerPublicProfile } from "../hooks/useGetWorkerPublicProfile";
import { ProfileImage } from "./ProfileImage";

interface WorkTogetherStackProps {
  workers: WorkerPublicProfile[];
  friendsMap?: Map<string, WorkerPublicProfile>;
  recentColleaguesMap?: Map<string, RecentColleague>;
}

export function WorkTogetherStack(props: WorkTogetherStackProps) {
  const { workers, friendsMap, recentColleaguesMap } = props;

  // display friends first, then recently worked together and then everybody else
  const friends = workers.filter((worker) => friendsMap?.has(worker.id));
  const recentlyWorkedTogether = workers.filter((worker) => recentColleaguesMap?.has(worker.id));
  const others = workers.filter(
    (worker) => !friendsMap?.has(worker.id) && !recentColleaguesMap?.has(worker.id)
  );
  const sortedWorkers = uniqBy([...friends, ...recentlyWorkedTogether, ...others], "id");

  return (
    <Stack flex={1} justifyContent="flex-end" flexDirection="row" sx={{ paddingRight: 3 }}>
      {sortedWorkers.slice(0, 2).map((worker, index) => (
        <ProfileImage
          key={worker.id}
          sx={{ marginRight: -3, outline: "1px solid white" }}
          size="small"
          src={worker.attributes.profileImageUrl}
          firstName={worker.attributes.firstName}
          lastName={worker.attributes.lastName}
          colorIndex={index}
        />
      ))}
      {sortedWorkers.length > 2 && (
        <Stack sx={{ marginRight: -3 }}>
          <ProfileImage
            sx={{ outline: "1px solid white" }}
            size="small"
            fallbackText={`+${sortedWorkers.length - 2}`}
            colorIndex={2}
          />
        </Stack>
      )}
    </Stack>
  );
}
